var _excluded = ["type", "icon", "label", "variant", "wasVisited", "theme", "tooltip", "target", "className", "textAlign"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { spacing } from "../../foundations/spacing";
import { useDefaultTheme } from "../../hooks/useDefaultTheme";
import { Icon } from "../Icon/Icon";
import { Tooltip } from "../Tooltip";
import { StyledLink, StyledRouterLink } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Link = function Link(props) {
  var type = props.type,
      icon = props.icon,
      label = props.label,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      _props$wasVisited = props.wasVisited,
      wasVisited = _props$wasVisited === void 0 ? false : _props$wasVisited,
      theme = props.theme,
      tooltip = props.tooltip,
      _props$target = props.target,
      target = _props$target === void 0 ? '_self' : _props$target,
      className = props.className,
      _props$textAlign = props.textAlign,
      textAlign = _props$textAlign === void 0 ? 'center' : _props$textAlign,
      rest = _objectWithoutProperties(props, _excluded);

  var defaultTheme = useDefaultTheme(theme);

  var Content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [label, icon && /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
      icon: icon.name
    }, icon), {}, {
      size: icon.size || spacing.size05,
      theme: defaultTheme
    }))]
  });

  var tooltipLabel = target === '_blank' ? tooltip : '';
  var linkClassName = tooltipLabel ? '' : className;
  return /*#__PURE__*/_jsx(Tooltip, {
    label: tooltipLabel,
    position: "bottom-right",
    className: className,
    children: type === 'router' ? /*#__PURE__*/_jsx(StyledRouterLink, _objectSpread(_objectSpread({}, rest), {}, {
      to: props.to,
      variant: variant,
      $wasVisited: wasVisited,
      theme: defaultTheme,
      target: target,
      className: linkClassName,
      textAlign: textAlign,
      children: Content
    })) : /*#__PURE__*/_jsx(StyledLink, _objectSpread(_objectSpread({}, rest), {}, {
      href: props.href,
      variant: variant,
      $wasVisited: wasVisited,
      theme: defaultTheme,
      target: target,
      className: linkClassName,
      textAlign: textAlign,
      children: Content
    }))
  });
};